// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailQ":"Q_wave2DetailQ__Urcmf"};